import DataService from "../../../services/client/classes/dataService";
import { IGetEventsOutput } from '../models/interfaces/iGetEventsOutput';
import { IEventForm } from '../models/interfaces/iEventForm';

export class EventsService extends DataService {
  constructor() {
    super('/private/database/events/');
  }

  getUpcomingEvents(data: IGetEventsOutput): JQuery.jqXHR {
    return this.get('getUpcomingEvents/', data);
  }

  create(data: IEventForm): JQuery.jqXHR<any> {
    return this.post('create', data);
  }

  update(data: any): JQuery.jqXHR<any> {
    return this.post('update', data);
  }
  delete(event_key: string): JQuery.jqXHR<any> {
    return this.post('delete', { id: event_key });
  }

  updateShortlistedEvent(data: IGetEventsOutput): JQuery.jqXHR {
    return this.post('update_shortlisted_event', data);
  }

}

export default new EventsService();



// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/eventsService.ts